import { AuthenticationServiceTokens as Tokens } from '../di-tokens';
import type { JWT, ResetPasswordService, JWTLoginSessionManager } from '../services';
import type { LogoutUseCase } from './logout';

/**
 * User has received a password reset email and wants to reset a password.
 */
export class ResetPasswordUseCase {
    public static inject = [
        Tokens.SessionManager,
        Tokens.ResetPasswordService,
        Tokens.RedirectService,
        Tokens.LogoutUseCase,
    ] as const;

    public constructor(
        private readonly sessionManager: JWTLoginSessionManager,
        private readonly authService: ResetPasswordService,
        private readonly navigator: { redirectToLoginPage() },
        private readonly logoutUseCase: LogoutUseCase
    ) {}

    public async resetPasswordAndRedirectToLoginPage(token: JWT, password: string) {
        if (this.sessionManager.isLoggedIn()) {
            await this.logoutUseCase.logOut(false).catch(console.error);
        }
        await this.authService.resetPassword(token, password);
        await this.navigator.redirectToLoginPage();
    }
}
